import { Component } from 'react';
import { inject, observer } from 'mobx-react';

//components
import withLocalization from '~/hoc/withLocalization';
import applicationRouter from '~/hoc/applicationRouter';
import TimeBank from '../TimeBank/TimeBank';
import OvertimeBank from '../OvertimeBank/OvertimeBank';

//styles
import '../../../styles/css/styles.css';

const resolveTabAndTransactionId = (props) => {
    const state = props.router?.location?.state;
    if (state?.tab) {
        return { tab: state.tab === 'overtimebank' ? 2 : 1, transactionId: state.transactionId || null };
    }
    const pathname = props.router?.location?.pathname || '';
    const tab = pathname.includes('/banks/overtimebank') ? 2 : 1;
    const transactionId = props.router?.params?.transactionId || null;
    return { tab, transactionId };
};

class Banks extends Component {
    constructor(props) {
        super(props);
        const resolved = resolveTabAndTransactionId(props);
        this.state = {
            currenttab: resolved.tab,
            transactionId: resolved.transactionId,
        }
    }

    componentDidUpdate(prevProps) {
        const prevState = prevProps.router?.location?.state;
        const prevPathname = prevProps.router?.location?.pathname;
        const state = this.props.router?.location?.state;
        const pathname = this.props.router?.location?.pathname;
        if (prevState !== state || prevPathname !== pathname) {
            const resolved = resolveTabAndTransactionId(this.props);
            this.setState({ currenttab: resolved.tab, transactionId: resolved.transactionId });
        }
    }

    Opentab = (tabid) => {
        this.setState({ currenttab: tabid, transactionId: null });
    };

    getComponent = (tab) => {
        const { t, commonStore } = this.props;
        const { transactionId } = this.state;
        const basicRules = commonStore?.config?.client?.data?.basicRules;
        const notEnabled = <div className='d-flex justify-content-center fw-600 align-items-center' style={{ minHeight: '200px' }}>{t('Feature is disabled, please contact administrator')}</div>;

        if (tab === 2)
            return basicRules?.overtimeBankSettings?.allowOvertimeBank ? <OvertimeBank transactionId={transactionId} /> : notEnabled;
        return basicRules?.timeBankSettings?.allowTimeBank ? <TimeBank /> : notEnabled;
    };

    render() {
        const { t } = this.props;
        return (
            <>
                <div className='tabContainer'>
                    <button className={(this.state.currenttab === 1 ? "tablink tablink__active-left-doc" : "tablink tablink__left-doc")} onClick={() => this.Opentab(1)}>
                        {t('Time Bank')}
                    </button>
                    <button className={(this.state.currenttab === 2 ? "tablink tablink__active-right-doc" : "tablink tablink__right-doc")} onClick={() => this.Opentab(2)}>
                        {t('Overtime Bank')}
                    </button>
                </div>
                <div className="page">{this.getComponent(this.state.currenttab)}</div>
            </>
        );
    }
}
export default inject('commonStore')(applicationRouter(withLocalization(observer(Banks))));
